/**
 * Who publishes and hosts the site, as the LCEN requires it on the legal notice. Kept in
 * one place because the privacy policy names the same controller and contact address.
 */
export const LEGAL = {
  publisher: {
    name: "Clément Baudet",
    status: "entrepreneur individuel",
    registration: "SIRET 912 065 166 00015",
    director: "Clément Baudet",
  },
  contactEmail: "contact@listou.fr",
  host: {
    name: "Hetzner Online GmbH",
    address: "Industriestr. 25, 91710 Gunzenhausen, Allemagne",
    phone: "+49 9831 505-0",
  },
  /** Date shown as "dernière mise à jour". Change it with every edit to the policy. */
  updatedAt: "29 septembre 2026",
} as const;
